import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-zinc-800 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-zinc-400">
              Forged by{' '}
              <a 
                href="https://x.com/OGNodeFather" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-violet-400 hover:text-violet-300 transition-colors"
              >
                Node Father
              </a>
              , Copyright 2025.
            </p>
          </div>

          <div className="flex items-center space-x-6 text-sm">
            <a href="/about" className="text-zinc-400 hover:text-white transition-colors">
              About
            </a>
            <a href="/api" className="text-zinc-400 hover:text-white transition-colors">
              API
            </a>
            <a href="/terms" className="text-zinc-400 hover:text-white transition-colors">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;